import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { UserData } from 'app/shared/service/UserService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopUpService {

  apiUrl: string = UserData.backend_url + '/v1';
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  lesson: any;
  popUpLesson = 'Placeholder';
  gameSettingRecords:any;

  constructor(private http: HttpClient) { }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
        headers: new HttpHeaders({
            'Authorization': authorizationString
        })
    };
    return httpOptions;
  }

  open(lesson:any) {
    this.lesson = lesson;
    this.isOpenSubject.next(true);
  }

  close() {
    this.isOpenSubject.next(false);
    this.popUpLesson = 'Placeholder';
    this.lesson = null;
  }

  fetchGameSettings(gameId: string) {
    return this.http.get(`${this.apiUrl}/user-setting/fetch/${gameId}`, this.getHeader());
  }

  postGameSettings(requestBody: any) {
    return this.http.post(`${this.apiUrl}/user-setting/create`, requestBody, this.getHeader());
  }

}
